import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Dialog,
  Typography,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  DialogTitle,
  CircularProgress,
  Switch,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { Formik } from "formik";

import { DropNCrop } from "../../../utils/DropNCrop";

import * as schoolDUCK from "../../../../redux/ducks/school.duck";
import { setLoader } from "../../../../redux/ducks/load.duck";
import {
  createSpotlight,
  updateSpotlight,
} from "../../../crud/api/spotlight.crud";
import { getContents } from "../../../crud/api/content.crud";
import notice from "../../../utils/notice";

const SpotlightDialog = ({ mode, setDialog, spotlight, onRefresh }) => {
  const title = mode === "editing" ? "Edit Spotlight" : "Create New Spotlight";
  const open = mode === "editing" || mode === "create";
  const [loading, setLoading] = useState(false);
  const [contents, setContents] = useState([]);

  useEffect(() => {
    if (open) {
      console.log("Cargando contenidos...");
      getContents(
        (data) => {
          console.log("Datos recibidos de getContents:", data);
          console.log("Items:", data.items);
          setContents(data.items || []);
        },
        1,
        1,
        "",
        false,
        0
      );
    }
  }, [open]);

  const create = async (values) => {
    try {
      setLoading(true);
      await createSpotlight(values);
      notice("Spotlight created successfully", "success");
      setDialog("close");
      if (onRefresh) {
        onRefresh();
      }
    } catch (error) {
      notice("Error creating spotlight", "error");
    } finally {
      setLoading(false);
    }
  };

  const update = async (values) => {
    try {
      setLoading(true);
      const dataToUpdate = {
        ...values,
        id: spotlight.id,
      };
      await updateSpotlight(dataToUpdate);
      notice("Spotlight updated successfully", "success");
      setDialog("close");
      if (onRefresh) {
        onRefresh();
      }
    } catch (error) {
      console.error("Error updating spotlight:", error);
      notice("Error updating spotlight", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setDialog("close")}
      maxWidth="md"
      fullWidth
      id="school_dialog"
    >
      <Formik
        initialValues={{
          title: spotlight?.title || "",
          description: spotlight?.description || "",
          link_button_text: spotlight?.link_button_text || "",
          linked_resource: spotlight?.linked_resource || "",
          cover_url: spotlight?.cover_url || "",
          active: spotlight?.active || false,
        }}
        validate={(values) => {
          const errors = {};

          if (!values.title || values.title.trim() === "") {
            errors.title = "Title is required";
          }

          if (!values.description || values.description.trim() === "") {
            errors.description = "Description is required";
          }

          if (
            !values.link_button_text ||
            values.link_button_text.trim() === ""
          ) {
            errors.link_button_text = "Link button text is required";
          }

          if (!values.linked_resource || values.linked_resource === "") {
            errors.linked_resource = "Please select a content";
          }

          if (!values.cover_url) {
            errors.cover_url = "Cover image is required";
          }

          return errors;
        }}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            if (spotlight?.id) {
              await update(values);
            } else {
              await create(values);
            }
          } catch (error) {
            console.error("Error in form submission:", error);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
            <DialogTitle disableTypography>
              <Typography variant="h6">{title}</Typography>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={4}>
                <Grid container item xs={12}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    id="spotlight_title_input_dialog"
                    label="Title"
                    name="title"
                    value={values.title}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.title && errors.title}
                    error={Boolean(touched.title && errors.title)}
                  />
                </Grid>
                <Grid container item xs={12}>
                  <h5>Cover image *</h5>
                  <div style={{ width: "100%" }}>
                    <DropNCrop
                      setterFunction={setFieldValue}
                      file={values.cover_url}
                      field="cover_url"
                    />
                  </div>
                  {touched.cover_url && errors.cover_url && (
                    <div
                      style={{
                        color: "#f44336",
                        fontSize: "0.75rem",
                        marginTop: "4px",
                      }}
                    >
                      {errors.cover_url}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    id="description_input_dialog"
                    label="Content text"
                    name="description"
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.description && errors.description}
                    error={Boolean(touched.description && errors.description)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    id="link_button_text_input_dialog"
                    label="Link Button text"
                    name="link_button_text"
                    value={values.link_button_text}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.link_button_text && errors.link_button_text
                    }
                    error={Boolean(
                      touched.link_button_text && errors.link_button_text
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    error={Boolean(
                      touched.linked_resource && errors.linked_resource
                    )}
                  >
                    <InputLabel id="linked_resource_label">
                      Linked resource
                    </InputLabel>
                    <Select
                      labelId="linked_resource_label"
                      id="linked_resource_input_dialog"
                      name="linked_resource"
                      value={values.linked_resource}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      label="Linked resource"
                    >
                      <MenuItem value="">
                        <em>Select a content</em>
                      </MenuItem>
                      {contents.length > 0 ? (
                        contents.map((content) => (
                          <MenuItem key={content.id} value={content.id}>
                            {content.title}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>
                          <em>No contents available</em>
                        </MenuItem>
                      )}
                    </Select>
                    {touched.linked_resource && errors.linked_resource && (
                      <div
                        style={{
                          color: "#f44336",
                          fontSize: "0.75rem",
                          marginTop: "4px",
                        }}
                      >
                        {errors.linked_resource}
                      </div>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Switch
                    name="active"
                    id="active_input_dialog"
                    checked={values.active}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    label={"Active"}
                  />
                  <span>Active</span>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                id="cancel_school_btn_dialog"
                onClick={() => setDialog("close")}
                color="secondary"
              >
                Cancel
              </Button>
              <button
                type="submit"
                id="submit_school_btn_dialog"
                disabled={
                  isSubmitting ||
                  !values.title ||
                  !values.description ||
                  !values.link_button_text ||
                  !values.linked_resource ||
                  !values.cover_url
                }
                className="btn btn-primary btn-elevate kt-login__btn-primary d-flex"
              >
                {mode === "editing" ? "Submit" : "Create"}
                {loading && (
                  <CircularProgress
                    color="inherit"
                    size={18}
                    style={{ marginLeft: 10 }}
                  />
                )}
              </button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => ({
  schoolActions: bindActionCreators(schoolDUCK.actions, dispatch),
  settingLoader: bindActionCreators(setLoader, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SpotlightDialog);
